import { useTranslation } from 'react-i18next';

import { OpenDuty } from '../types';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import getCommonTooltipContent from '../TooltipContent';
import { Icon } from '@sdb/planning-ui';

export default function TooltipContent(duty: OpenDuty, portal: string) {
  const { t } = useTranslation('common');
  const isRosterPortal = portal === 'roster';
  const {
    subscribedEmployees,
    sentToFlex,
    isSentForSelfMatch,
    preferredEmployees
  } = duty;
  const commonContent = getCommonTooltipContent(duty);
  const hasSubscribers = Boolean(subscribedEmployees?.length);
  const showSentToFlex = sentToFlex;
  const hasPreferredEmployees =
    isRosterPortal && Boolean(preferredEmployees?.length);
  // const isNotFromBaseplan = !isFromBasePlan;
  const isNotFromBaseplan = false;
  const hasContent =
    commonContent ||
    hasSubscribers ||
    showSentToFlex ||
    isSentForSelfMatch ||
    hasPreferredEmployees ||
    isNotFromBaseplan ||
    !duty.isPublished;

  if (!hasContent) return '';

  return (
    <Table size="small" sx={{ 'tr:last-child td': { border: 0 } }}>
      <TableBody>
        {!duty.isPublished && (
          <TableRow>
            <TableCell colSpan={2}>
              <strong>
                <i>{t('notPublished')}</i>
              </strong>
            </TableCell>
          </TableRow>
        )}
        {isNotFromBaseplan && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="chevron-up" fontSize="small" />
            </TableCell>
            <TableCell>{t('notFromBaseplan')}</TableCell>
          </TableRow>
        )}
        {showSentToFlex && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="arrow-right-arrow-left" fontSize="small" />
            </TableCell>
            <TableCell>{t('isSentToFlex')}</TableCell>
          </TableRow>
        )}
        {isSentForSelfMatch && (
          <TableRow>
            <TableCell style={{ fontSize: 0 }}>
              <Icon type="users" fontSize="small" />
            </TableCell>
            <TableCell>{t('openForSelfMatch')}</TableCell>
          </TableRow>
        )}
        {hasSubscribers && (
          <TableRow>
            <TableCell style={{ verticalAlign: 'top' }}>
              <Icon type="users" fontSize="small" />
            </TableCell>
            <TableCell>
              <div>
                <strong>{t('subscribers')}</strong>
              </div>
              {duty.subscribedEmployees?.map(({ nameInformal, id, number }) => (
                <div key={id || number}>{nameInformal}</div>
              ))}
            </TableCell>
          </TableRow>
        )}
        {hasPreferredEmployees && (
          <TableRow>
            <TableCell>
              <Icon type="user-crown" fontSize="small" />
            </TableCell>
            <TableCell>
              <div>
                <strong>{t('preferredEmployees')}</strong>
              </div>
              {duty.preferredEmployees?.map(({ nameInformal, id, number }) => (
                <div key={id || number}>{nameInformal}</div>
              ))}
            </TableCell>
          </TableRow>
        )}
        {commonContent}
      </TableBody>
    </Table>
  );
}
